import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";

import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { CreditMemo } from "@portal/types/entities/credit-memo";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { useParams } from "react-router-dom";

function ReferenceCell(props: CellRenderProps<CreditMemo>) {
  const { data } = props;
  const navigate = usePageNavigate();
  const { customer_id } = useParams<AppPageParams>();

  function handleQueryParams() {
    navigate({
      appPage: "CREDIT_DETAILS",
      pathParams: {
        customer_id: customer_id as string,
        credits_id: data?.id as string,
      },
    });
  }
  return (
    <TextColumn
      type="Link"
      text={data?.reference}
      linkProps={{ strong: true, onClick: handleQueryParams }}
    />
  );
}

export { ReferenceCell };
